import * as yup from 'yup'

const assetSchema = yup.object().shape({
  code: yup.string().nullable().optional(),
  account: yup.string().nullable().optional(),
  amount: yup.string().nullable().optional(),
})

export const balanceSheetFileDataSchema = yup.object().shape({
  title: yup.string().nullable().optional(),
  date: yup.string().nullable().optional(),
  description: yup.string().nullable().optional(),
  currentAssets: yup.array().of(assetSchema).required(),
  fixedAssets: yup.array().of(assetSchema).required(),
  otherAssets: yup.array().of(assetSchema).required(),
  currentLiabilities: yup.array().of(assetSchema).required(),
  otherLiabilities: yup.array().of(assetSchema).required(),
  equities: yup.array().of(assetSchema).required(),
})

export type BalanceSheetFileData = yup.InferType<typeof balanceSheetFileDataSchema>

export const balanceSheetFileMappings = {
  title: 'f69c724f-ed26-4073-81c3-b3e8604b4df1',
  date: 'f0fc4e90-9209-4e90-9ed6-fa73dcb3aa45',
  description: '77127186-0ead-495b-b78c-011bc7d326a6',
  currentAssets: [
    {
      code: '366f0852-36e6-403d-979a-e2ab140fbb19',
      account: '6b62c881-0f26-454b-a9b6-118533dc6d47',
      amount: 'c2b6b29c-95c6-4d2d-8403-e1c43314122a',
    },
  ],
  fixedAssets: [
    {
      code: '63d343ae-1b92-45d5-bd94-f59fbcb8bb89',
      account: '28aceddb-da30-4cb5-98ea-ce71d9e3fc89',
      amount: '934f9ba3-112a-4341-aa59-efac4f62d16d',
    },
  ],
  otherAssets: [
    {
      code: 'f4a89cf3-ee5d-42ee-8ac1-147480f18144',
      account: 'ea7b0b76-773a-42d7-ad06-c9192f595b69',
      amount: '609c39a2-df12-42a6-afd6-b1c3729942ab',
    },
  ],
  currentLiabilities: [
    {
      code: '17a6f947-678e-4aaa-a6a5-e8d4654f7c34',
      account: '3dbecbe3-5595-4ac7-89f7-1fc3c2dcb202',
      amount: 'cb85836b-ca1d-480d-96e0-7bf85b3ad98b',
    },
  ],
  otherLiabilities: [
    {
      code: 'e5508c60-26e0-496d-935c-9a48d32c03fe',
      account: 'ab10fc71-f520-4bf2-bf5f-3b8a6ce4c906',
      amount: '6c1472d6-caee-4ad8-96e0-605337d277cf',
    },
  ],
  equities: [
    {
      code: 'b10a88bc-ef13-4341-8340-ffaa7714f2c4',
      account: '2d02168b-3126-43d6-9ba8-86adb8361ea1',
      amount: 'e8ee7878-a5d9-477b-9bcb-52696148c35d',
    },
  ],
}
